/*
 * FSS Rewards Points — dynamic variant update
 * Uses Atelier theme's native 'variant:update' event
 * e.detail.resource contains the full variant object including price
 */
(function() {
  var RATE = 5; // points per £1

  function updatePoints(priceInCents) {
    var els = document.querySelectorAll('[data-fss-points-value]');
    var wrappers = document.querySelectorAll('.fss-rewards-points');
    if (!els.length) return;
    if (!priceInCents || priceInCents <= 0) {
      wrappers.forEach(function(el) { el.style.display = 'none'; });
      return;
    }
    var points = Math.round((priceInCents / 100) * RATE);
    els.forEach(function(el) { el.textContent = points; });
    wrappers.forEach(function(el) { el.style.display = ''; });
  }

  // Atelier native event: variant:update
  // Fired by VariantUpdateEvent in events.js after fetch completes
  // e.detail.resource = full variant object with .price in cents
  document.addEventListener('variant:update', function(e) {
    var resource = e.detail && e.detail.resource;
    if (resource && typeof resource.price === 'number') {
      updatePoints(resource.price);
    }
  });

  // Close modal on backdrop click
  document.addEventListener('click', function(e) {
    var modal = document.getElementById('fss-club-modal');
    if (modal && modal.open && e.target === modal) {
      modal.close();
    }
  });

  // Close modal on ESC (native dialog handles this already, but just in case)
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('fss-club-modal');
      if (modal && modal.open) modal.close();
    }
  });

})();
